import { useEffect } from 'react';

import { GENERATION_MODE_TYPE } from 'src/data/generation';
import {
  getBackendResourcesFromTool,
  getToolMixtureSubGenerationTools,
  isMixtureTool,
} from 'src/data/generationTool';
import { useDefaultBrandVoiceAssets, useProjectActions } from 'src/store';

import { useLocalActions } from '../store';

import { useGenerationTool } from './useGenerationTool';

export const useMaintainGenerationToolData = () => {
  const projectActions = useProjectActions();
  const generationTool = useGenerationTool();
  const localActions = useLocalActions();
  const generationToolOptionsCache = localActions.getGenerationToolOptionsCache();

  const { customModels, toneOfVoices, customFormulas } = useDefaultBrandVoiceAssets();

  useEffect(() => {
    const defaultTov = toneOfVoices?.find((item) =>
      item.defaultForGenerationTools?.includes(generationTool)
    );
    const toolDataSources = getBackendResourcesFromTool(generationTool);
    const defaultCustomModel = customModels?.find(
      (customModel) => toolDataSources.includes(customModel.dataSource) && customModel.isDefault
    );
    if (defaultTov) {
      projectActions.updateToneOfVoice(defaultTov.id);
    } else if (defaultCustomModel) {
      projectActions.setSelectedCustomModelId(defaultCustomModel.id);
    } else {
      projectActions.clearSelectedCustomModelId();
    }

    return () => projectActions.clearSelectedCustomModelId();
  }, [projectActions, generationTool, customModels, toneOfVoices]);

  useEffect(() => {
    if (isMixtureTool(generationTool)) {
      const tools = getToolMixtureSubGenerationTools(generationTool);
      tools.forEach((tool) => {
        if (
          generationToolOptionsCache?.[generationTool]?.subGenerationToolsProps?.[tool]
            ?.selectedModeType
        ) {
          localActions.selectSubGenerationToolTemplate(
            generationToolOptionsCache?.[generationTool]?.subGenerationToolsProps?.[tool]
              ?.selectedModeId,
            generationToolOptionsCache?.[generationTool]?.subGenerationToolsProps?.[tool]
              ?.selectedModeType,
            tool
          );
        } else {
          const customFormula = customFormulas?.find(
            (customFormula) =>
              customFormula.generationTool === tool && customFormula.isDefault === true
          );
          if (customFormula) {
            localActions.selectSubGenerationToolTemplate(
              customFormula.id,
              GENERATION_MODE_TYPE.customFormula,
              tool
            );
          }
        }
      });
      return;
    } else {
      if (generationToolOptionsCache?.[generationTool]?.selectedModeType) {
        return;
      }
      const customFormula = customFormulas?.find(
        (customFormula) =>
          customFormula.generationTool === generationTool && customFormula.isDefault === true
      );
      if (customFormula) {
        localActions.selectTemplate(customFormula.id, GENERATION_MODE_TYPE.customFormula);
      }
    }
  }, [generationTool, customFormulas, localActions, generationToolOptionsCache]);
};
